import { HistoryTab } from "./HistoryTab";
import { Layout } from "./Layout";

export const HistoryPage = () => (
  <Layout activeTab="history">
    <HistoryTab />
  </Layout>
);
